import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { trackEvent } from '../utils/trackEvents'; 
import { API_BASE_URL } from '../utils/apiConfig';

export default function PopupModal({ id, name, message, type, responses, image, linkPage, secondaryMessage, secondaryResponses, isDismissible, onClose }) {
  const [answer, setAnswer] = useState('');
  const [secondAnswer, setSecondAnswer] = useState('');
  const navigate = useNavigate();

  const handleAnswerChange = (e) => {
    const index = e.target.value;
    setAnswer(index);
  };

  const handleSecondaryAnswerChange = (e) => {
    const index = e.target.value;
    setSecondAnswer(index);
  }


  const handleSubmit = async (e) => {
    e.preventDefault();

    const link = linkPage[answer];
    const sessionId = sessionStorage.getItem("sessionId");

    trackEvent(sessionId, "POPUP_SUBMIT", name, {
        popupId: id,
        answer: responses[answer],
        secondaryAnswer: secondaryResponses[secondAnswer]
    });

    if(type === 'Multiple-Choice') {
        try {
            await axios.post(`${API_BASE_URL}/api/popup-responses`, {
                popupId: id,
                popupName: name,
                sessionId: sessionId,
                response: [responses[answer], secondaryResponses[secondAnswer]]
            });
        } catch (error) {
            console.error(error);
        }
    }

    onClose();

    if((secondaryResponses[secondAnswer] !== 'No') || (type === 'Message')) {
        trackEvent(sessionId, "POPUP_NAVIGATE", name, {
            popupId: id,
            link
        });

        navigate(link);
    }
  };

  const handleClose = () => {
    const sessionId = sessionStorage.getItem("sessionId");

    trackEvent(sessionId, "POPUP_DISMISS", name, {
        popupId: id
    });

    onClose();
    };
    
  useEffect((handleClose) => {
    const handler = (e) => {
      if (e.key === 'Escape' && isDismissible) handleClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose, isDismissible]);

    useEffect(() => {
        const sessionId = sessionStorage.getItem("sessionId");

        trackEvent(sessionId, "POPUP_VIEW", name, {
            popupId: id,
            message
        });
    }, [id, message, name]);

  return (
    <div className="popup-backdrop" onClick={isDismissible ? handleClose : null}>
      <div className="popup-box" onClick={e => e.stopPropagation()}>
        {(isDismissible === 1) && 
            <div className="close-popup-btn">
                <button onClick={handleClose}>✖</button>
            </div>
        }

        {(image) && 
            <img
                src={image}
                alt={" "}
                onError={(e) => {
                    if (e.target.src !== window.location.origin + "/imageComingSoon.jpg") {
                        e.target.src = "/imageComingSoon.jpg";
                    }
                }}
            />
        }

        {(type === 'Multiple-Choice') &&
            <div>
                <form className="popup-form" onSubmit={handleSubmit}>
                    <h5>{message}</h5>
                    <select name="response" className="modern-input" onChange={handleAnswerChange} required >
                        <option></option>
                        {responses.map((response, index) => (
                            <option value={index}>{response}</option>
                        ))}                
                    </select>
                    {secondaryMessage && <h5>{secondaryMessage}</h5> }
                    {secondaryResponses[0] && <select name="secondaryResponse" className="modern-input" onChange={handleSecondaryAnswerChange} required >
                        <option></option>
                        {secondaryResponses.map((response, index) => (
                            <option value={index}>{response}</option>
                        ))}                
                    </select>}
                    <button className="action-btn" type="submit">Submit</button>
                </form>
            </div>
        }
        {(type === 'Message') && 
            <div className="popup-form">
                <h5>{message}</h5>
                <button className="action-btn" onClick={handleSubmit}>Close</button>
            </div>
        }
      </div>
    </div>
  );
}